import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { AppState, franchiseSelector, submissionSelector } from 'common/store/store';
import React from 'react';
import { useSelector } from 'react-redux';
import { apiJson } from '../api';
import { Loading } from '../views/Loading';


export const AvertrirFranchiseSoumission = (props: { submissionId: ModelId, onClose: () => void; }) => {

    const submission = useSelector((state: AppState) => submissionSelector.selectById(state, props.submissionId));
    const franchise = useSelector((state: AppState) => franchiseSelector.selectById(state, submission?.franchiseId ?? 0));

    const [loading, setLoading] = React.useState(false);


    const onAccepterClick = async () => {
        if (submission) {
            setLoading(true);
            await apiJson('/submission/alertFranchise/', 'post', { submissionId: submission.id });
            setLoading(false);
            props.onClose();
        }

    };

    if (submission?.id === props.submissionId && franchise?.id === submission?.franchiseId && !!franchise.email) {
        return <Dialog open={!!props.submissionId} onClose={() => props.onClose()}>
            <DialogTitle>{'Avertir la franchise ?'}</DialogTitle>
            <DialogContent>
                {loading ? <Loading /> : null}
                <DialogContentText>
                    La soumission a été affecté à la franchise <strong>{franchise.name}</strong>. Voulez-vous avertir {franchise.contactName ?? 'Le responsable'} de sorte qu'il la reçoive un message « nouvelle soumission reçue » ?
                </DialogContentText>
                <DialogActions>
                    <Button variant='contained' onClick={onAccepterClick} autoFocus>Oui</Button>
                    <Button onClick={() => props.onClose()}>Non</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>;
    } else {
        return <></>;
    }
};
